import React, {createContext}  from "react";

const LangContext = createContext({lang: null, setLanguage: () => {}});

export default LangContext;

